import React, { useState } from 'react';
import { array, func, string } from 'prop-types';
import { useDispatch } from 'react-redux';
import cx from 'classnames';

import { push } from 'reduxModules/navigation/action';
import useStyles from 'hooks/useStyles';
import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';
import { LIVE_SYLLABUS } from 'constants/routingPath';
import { ArrowIcon } from 'components/Icon';
import Tabs from 'components/Tabs';

import styles from './SyllabusTab.scss';

const SyllabusTab = ({
  tabPanes,
  title,
  currentLessonId,
  liveTopicId,
  className,
  onSyllabusLessonClick,
}) => {
  useStyles(styles);
  const dispatch = useDispatch();
  const getOfficialSiteURL = useGetOfficialSiteURL();
  const [currentMouseOverId, setCurrentMouseOverId] = useState(null);

  const toSyllabusPage = (lessonId, lessonName, syllabusName) => {
    if (typeof onSyllabusLessonClick === 'function') {
      onSyllabusLessonClick(lessonName, syllabusName);
    }
    dispatch(
      push(getOfficialSiteURL(LIVE_SYLLABUS, { id: liveTopicId, lessonId })),
    );
  };

  const handleLinkMouseOver = lessonId => {
    setCurrentMouseOverId(lessonId);
  };

  return (
    <div className={cx(styles.root, className)}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.tabContainer}>
        <Tabs
          classNameMap={{
            root: styles.tabs,
            tab: styles.tab,
            tabList: styles.tabList,
            tabSelected: styles.tabSelected,
            container: styles.tabContainer,
          }}
        >
          {tabPanes.map(({ id, name, syllabusLessons }) => (
            <Tabs.TabPane
              tabKey={id}
              key={id}
              tabTitle={name}
              className={styles.tabPane}
            >
              {syllabusLessons.map(({ name: lessonName, id: lessonId }) => (
                <div
                  key={lessonId}
                  className={styles.tabElement}
                  onClick={() => toSyllabusPage(lessonId, lessonName, name)}
                  onMouseEnter={() => handleLinkMouseOver(lessonId)}
                  onMouseLeave={() => handleLinkMouseOver(null)}
                >
                  <span
                    className={cx(styles.name, {
                      [styles.nameHover]: currentMouseOverId === lessonId,
                      [styles.nameActive]: currentLessonId === lessonId,
                    })}
                  >
                    {lessonName}
                  </span>
                  {currentMouseOverId === lessonId &&
                    currentLessonId !== lessonId && (
                      <ArrowIcon className={styles.arrowIcon} />
                    )}
                </div>
              ))}
            </Tabs.TabPane>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

SyllabusTab.propTypes = {
  tabPanes: array.isRequired,
  className: string,
  title: string,
  currentLessonId: string,
  liveTopicId: string.isRequired,
  onSyllabusLessonClick: func,
};

SyllabusTab.defaultProps = {
  className: '',
  title: '',
  currentLessonId: null,
  onSyllabusLessonClick: null,
};

export default SyllabusTab;
